import axios from "axios";

/* =====================================================
   AXIOS CLIENT
===================================================== */
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "",

  timeout: 30000,

  headers: {
    "Content-Type": "application/json",
  },
});

/* =====================================================
   REQUEST INTERCEPTOR
===================================================== */

apiClient.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("token");

    if (token) {
      config.headers.Authorization =
        `Bearer ${token}`;
    }

    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

/* =====================================================
   RESPONSE INTERCEPTOR
===================================================== */

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },

  (error) => {
    /*
     * Giữ nguyên AxiosError để các page đọc được:
     *
     * error.response.status
     * error.response.data
     */

    return Promise.reject(error);
  }
);

export default apiClient;